import axios from 'axios';

// API Base URL - automatically uses production or development URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000 // 10 seconds timeout
});

// Request interceptor - Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Server responded with error status
      if (error.response.status === 401) {
        // Unauthorized - clear token and redirect to login
        localStorage.removeItem('token');
        // You can add redirect logic here if needed
      }
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // Request made but no response
      return Promise.reject({
        success: false,
        message: 'Network error. Please check your connection.'
      });
    } else {
      // Something else happened
      return Promise.reject({
        success: false,
        message: error.message
      });
    }
  }
);

// API Methods
export const contactAPI = {
  // Submit contact form (Public)
  submit: (data) => api.post('/contacts', data),
  
  // Get all contacts (Protected)
  getAll: (params) => api.get('/contacts', { params }),
  
  // Get single contact (Protected)
  getById: (id) => api.get(`/contacts/${id}`),
  
  // Update contact (Protected)
  update: (id, data) => api.put(`/contacts/${id}`, data),
  
  // Delete contact (Protected - Admin only)
  delete: (id) => api.delete(`/contacts/${id}`),
  
  // Get statistics (Protected)
  getStats: () => api.get('/contacts/stats')
};

export const authAPI = {
  // Register user
  register: (data) => api.post('/auth/register', data),
  
  // Login user
  login: (data) => api.post('/auth/login', data),
  
  // Get current user
  getMe: () => api.get('/auth/me'),
  
  // Update user details
  updateDetails: (data) => api.put('/auth/updatedetails', data),
  
  // Update password
  updatePassword: (data) => api.put('/auth/updatepassword', data)
};

export const followUpAPI = {
  // Create follow-up
  create: (data) => api.post('/followups', data),
  
  // Get all follow-ups
  getAll: (params) => api.get('/followups', { params }),
  
  // Get single follow-up
  getById: (id) => api.get(`/followups/${id}`),
  
  // Update follow-up
  update: (id, data) => api.put(`/followups/${id}`, data),
  
  // Complete follow-up
  complete: (id, data) => api.put(`/followups/${id}/complete`, data),
  
  // Get by contact
  getByContact: (contactId) => api.get(`/followups/contact/${contactId}`),
  
  // Get upcoming
  getUpcoming: (days) => api.get('/followups/upcoming', { params: { days } }),
  
  // Get overdue
  getOverdue: () => api.get('/followups/overdue'),
  
  // Delete follow-up
  delete: (id) => api.delete(`/followups/${id}`)
};

export const activityAPI = {
  // Get activities by contact
  getByContact: (contactId) => api.get(`/activities/contact/${contactId}`),
  
  // Get recent activities
  getRecent: (limit) => api.get('/activities/recent', { params: { limit } })
};

export default api;
